let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eDqo1")).then(() => parcelRequire('jDMpf'));